module.exports = __webpack_public_path__ + "static/media/welding_1.01d63f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/welding_1.jpg
// module id = 1867
// module chunks = 0